import React from 'react'
import { Avatar } from '../../../components/avatar'
import { PhoneConversationData } from './conversation'
import { AudioPlayer } from '../../../components/simple/audio'

export const PhoneConversation: React.FC<{ data: PhoneConversationData }> = ({ data }) => {
  return (
    <div className="flex flex-col gap-2 p-2">
      <div className="flex items-center gap-2">
        <Avatar src={data.messageForTags.avatar} />
        {data.messageForTags.lk ? (
          <div>Interpreted Call Info</div>
        ) : data.messageForTags.conference ? (
          <div>Video Call Info</div>
        ) : (
          <div>Call Info</div>
        )}
        {data.callAudioUrl && <AudioPlayer className="ml-auto" src={data.callAudioUrl} />}
      </div>
      {data.lkMessageInfo && <div className="m-3" dangerouslySetInnerHTML={{ __html: data.lkMessageInfo }}></div>}
      {data.callTranscript ? (
        <div className="flex flex-col gap-2">
          {data.callTranscript.map((message, index) => (
            <div
              key={index}
              className={`rounded p-2 ${message.speaker === 'left' ? 'mr-auto bg-gray-50' : 'ml-auto bg-logo text-white'}`}
            >
              {message.text}
            </div>
          ))}
        </div>
      ) : (
        <>Transcript Pending...</>
      )}
    </div>
  )
}
